import { Grid, theme } from 'antd';

const { useBreakpoint } = Grid;

/**
 * Form label'ı — iki kullanım:
 *   external={false} → Input/InputNumber'ın addonBefore slot'u (antd zaten .ant-input-group-addon
 *                      kabuğunu ve zeminini basar; burada sadece metin biçimlenir).
 *   external={true}  → Input'un DIŞINDA, kendi başına duran addon bloğu (Kimlik, Cinsiyet,
 *                      Doğum Tarihi). antd v5'te .ant-input-number-group-addon stilleri hash'li
 *                      bileşen sınıfına bağlı ve bileşen dışında UYGULANMIYOR — zemin/padding/
 *                      yükseklik burada açıkça verilmeli, yoksa label şeffaf zeminde kayboluyor.
 *
 * `width` iki varyantta da kutunun DIŞ genişliğidir: slot varyantında antd'nin eklediği
 * padding + kenarlık içerik genişliğinden düşülür, böylece yan yana/alt alta duran gri
 * kutular aynı ölçüde çıkar. Yükseklik de small kontrol yüksekliğine (controlHeightSM)
 * bağlı — form size="small" ile çalışıyor.
 */
const AddonBefore = ({ width, external, style = {}, children }) => {
    const screens = useBreakpoint();
    const { token } = theme.useToken();
    const isMobile = !screens.md;
    // Mobilde geniş label'lar input alanını eziyor — dış genişlik 85px'i geçmesin
    const outerWidth = isMobile ? Math.min(width, 85) : width;
    // Mobilde input'lar index.css'te 38px'e büyütülüyor
    const controlHeight = isMobile ? 38 : token.controlHeightSM;
    // antd Input/InputNumber small addon: padding = controlPaddingHorizontalSM - lineWidth (her iki yan),
    // kenarlık yalnız sol tarafta (sağ kenar input'la paylaşılıyor)
    const slotPadding = token.controlPaddingHorizontalSM - token.lineWidth;
    const slotContentWidth = outerWidth - 2 * slotPadding - token.lineWidth;

    // Label metni renkli kart zeminlerinin (cinsiyet kutusu) üstünde de okunmalı.
    // nowrap: sabit genişlikli addon kutusunda "Doğum Tarihi" iki satıra kırılmasın.
    const labelText = {
        fontWeight: 600,
        color: 'var(--text)',
        fontSize: isMobile ? 12 : 13,
        lineHeight: 1.2,
        whiteSpace: 'nowrap',
    };

    if (external) {
        return (
            <div
                style={{
                    width: `${outerWidth}px`,
                    minWidth: `${outerWidth}px`,
                    height: controlHeight,
                    background: 'var(--surface-2)',
                    border: `${token.lineWidth}px solid ${token.colorBorder}`,
                    borderRadius: token.borderRadiusSM,
                    textAlign: 'start',
                    display: 'flex',
                    alignItems: 'center',
                    padding: `0 ${slotPadding}px`,
                    boxSizing: 'border-box',
                    ...labelText,
                    ...style
                }}
            >
                {children}
            </div>
        )
    }

    return (
        <div
            style={{
                width: slotContentWidth,
                minWidth: slotContentWidth,
                minHeight: isMobile ? controlHeight : undefined,
                textAlign: 'start',
                display: 'flex',
                alignItems: 'center',
                ...labelText,
                ...style
            }}
        >
            {children}
        </div>
    )
}

export default AddonBefore
